import PropTypes from 'prop-types';
import React from 'react';

export const relatedArticlesProps = PropTypes.arrayOf(
    PropTypes.shape({
        image: PropTypes.shape({
            src: PropTypes.string,
            alt: PropTypes.string,
        }),
        author: PropTypes.shape({
            img: PropTypes.string,
            authorName: PropTypes.string,
        }),
        title: PropTypes.string,
        text: PropTypes.node,
        button: PropTypes.bool,
    })
);
